import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { useEffect, useState } from "react";
import { I18nextProvider } from "react-i18next";
import { RouterProvider } from "react-router-dom";
import { setAuthLostHandler } from "@/api/client";
import { createAppRouter } from "@/app/router";
import { Toaster } from "@/components/ui/toast";
import i18n from "@/i18n";

const PUBLIC = ["/login", "/set-password", "/reset-password", "/forgot-password", "/signup", "/privacy", "/terms"];

export function App() {
  const [queryClient] = useState(
    () => new QueryClient({ defaultOptions: { queries: { staleTime: 30_000, refetchOnWindowFocus: false } } }),
  );
  const [router] = useState(() => createAppRouter());

  useEffect(() => {
    setAuthLostHandler((next) => {
      const here = router.state.location.pathname;
      // On public pages a failed refresh is expected; clearing there would refetch `me` forever.
      if (PUBLIC.some((p) => here.startsWith(p))) return;
      queryClient.clear();
      void router.navigate(`/login?next=${encodeURIComponent(next)}`, { replace: true });
    });
    return () => setAuthLostHandler(null);
  }, [queryClient, router]);

  return (
    <QueryClientProvider client={queryClient}>
      <I18nextProvider i18n={i18n}>
        <RouterProvider router={router} />
        <Toaster />
      </I18nextProvider>
    </QueryClientProvider>
  );
}
